<template>
  <div class="app-wrapper" :class="classObj">
    <el-container>
      <el-header class="header__box">
        <Tab />
      </el-header>
      <el-container>
        <el-aside class="aside__box" v-if="user.appList.length">
          <sidebar class="sidebar-container"></sidebar>
        </el-aside>
        <el-main class="main__box">
          <el-card class="box-card" shadow="never" :body-style="card_style">
            <div class="add_btn" @click="$router.push({ path: '/account/join' })">
              <i class="el-icon-circle-plus-outline"></i>
              <span>新增管理</span>
            </div>
            <div class="card__item" 
              :class="{'card__item--active': user.currentApp.id == item.id}"
              v-for="(item, index) in user.appList"
              @click="currentApp(item)">{{ item.nickname }}</div>
          </el-card>
          <div class="main__title-box">
            <el-button v-if="$route.meta.is_children"
              size="mini"
              @click="$router.go(-1)"
              icon="el-icon-d-arrow-left"
              type="primary" plain circle></el-button>
            &nbsp;&nbsp;{{ $route.meta.title }}
          </div>
          <div class="main_contant">
            <keep-alive>
              <router-view class="view" v-if="!$route.meta.noKeepAlive"></router-view>
            </keep-alive>
            <router-view class="view" v-if="$route.meta.noKeepAlive"></router-view>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { Sidebar } from './components'
import Tab from '@/components/Index/tab.vue'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'layout',
  data() {
    return {
      card_style: 'display:flex; align-items: center;padding: 5px;'
    }
  },
  components: {
    Sidebar,
    Tab
  },
  computed: {
    ...mapState(['user']),
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        // hideSidebar: !this.sidebar.opened,
        hideSidebar: false,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    // 配置方法
		...mapMutations({
      setCurrentApp: 'SET_CURRENTAPP',
    }),
    // 却换 app
    currentApp (item) {
      if (item.app_id !== this.$route.query.weChat) {
        this.setCurrentApp(item)
        this.$router.push({
          path: '/home',
        })
      }
    }
  },
  mounted () {
    if (!this.user.appList.length) {
      this.$router.replace({ name: 'Account' })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/assets/styles/mixin.scss';
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}

.header__box {
  height: 80px !important;
  padding: 0;
}
.aside__box {
  height: calc(100vh - 80px);
  width: 200px !important;
  position: relative;
  // margin-top: 10px;
  border-top-right-radius: 4px;
  &::-webkit-scrollbar {
    width: 0;
  }
}
.sidebar-container {
  &::-webkit-scrollbar {
    width: 0;
  }
}
.main__box {
  padding: 0;
  display: flex;
  flex-direction: column;
}
.main_contant {
  background-color: white;
  border-radius: 10px;
  padding: 15px;
  margin: 0 10px;
  position: relative;
  position: relative;
  flex: 1
}
.add_btn {
  border: 1px solid #2baac3;
  border-radius: 4px;
  width: 100px;
  height: 30px;
  color: #2baac3;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
}
.box-card {
  background-color: transparent;
  border: none;
  margin: 5px 10px;
}
.card__item {
  padding: 0 15px;
  height: 32px;
  background: transparent;
  border-radius: 4px;
  color: #2baac3;
  border: 1px solid #2baac3;
  line-height: 32px;
  margin-left: 10px;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  &--active {
    color: #2baac3;
    background: rgba(43, 170, 195, 0.6);
  }
}
.main__title-box {
  background-color: white;
  margin: 0 10px 10px;
  padding: 10px;
  font-size: 15px;
  font-weight: bold;
  border-left: 4px solid #2BAAC3;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  display: flex;
  align-items: center;
}
</style>
<style lang="scss">
.el-card__body {
  padding: 20px 0; 
}
</style>




// WEBPACK FOOTER //
// src/views/layout/Layout.vue